import {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";
import config from "../config";

const WalletContext = createContext(null);

export const WalletProvider = ({ children }) => {
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletLoading, setWalletLoading] = useState(false);
  const [walletError, setWalletError] = useState("");

  const refreshWallet = useCallback(async () => {
    setWalletLoading(true);
    setWalletError("");

    try {
      const response = await fetch(
        `${config.API_URL}/wallet.php?t=${Date.now()}`,
        {
          method: "GET",
          credentials: "include",
          cache: "no-store",
          headers: {
            Accept: "application/json",
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        }
      );

      const responseText = await response.text();

      let result;

      try {
        result = JSON.parse(responseText);
      } catch {
        console.error("Invalid wallet response:", responseText);
        throw new Error("Wallet API returned an invalid response.");
      }

      if (!response.ok || !result.success) {
        throw new Error(
          result.message || "Unable to load wallet balance."
        );
      }

      const updatedBalance = Number(result.walletBalance) || 0;

      setWalletBalance(updatedBalance);

      return updatedBalance;
    } catch (error) {
      console.error("Wallet refresh failed:", error);

      setWalletError(
        error.message || "Unable to load wallet balance."
      );

      return null;
    } finally {
      setWalletLoading(false);
    }
  }, []);

  return (
    <WalletContext.Provider
      value={{
        walletBalance,
        walletLoading,
        walletError,
        refreshWallet,
      }}
    >
      {children}
    </WalletContext.Provider>
  );
};

export const useWallet = () => {
  const context = useContext(WalletContext);

  if (!context) {
    throw new Error(
      "useWallet must be used inside WalletProvider."
    );
  }

  return context;
};